__turbopack_context__.v({
  "className": "inter_712c8b17-module__ZLgLCa__className",
});
